// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_fr-0";